import roundToSeconds from './roundToSeconds';

const calcSecondsLeft = (seconds: number, timestamp: number): number => {
    if (seconds < 1) {
        // Backend does not return minus seconds to be able to calc time backwards.
        // Even if it would return - we should not calc backwards. Round is started
        return 0;
    }

    const secondsLeft = seconds - (roundToSeconds(Date.now()) - roundToSeconds(timestamp));
    return Math.max(0, secondsLeft);
};

export default calcSecondsLeft;
